import { CommonModule } from '@angular/common';
import { Component, OnDestroy, OnInit, inject, input, output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ApplicationService } from 'eas-core-lib';
import { RoleRequestService } from 'src/app/modules/user-profile/services/role-request.service';
import { RoleRequestCartComponent } from '../role-request-cart/role-request-cart.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { TooltipModule} from 'ngx-bootstrap/tooltip';
import { SpinnerComponent } from 'src/app/modules/shared/components/spinner/spinner.component';
import { NgxSpinnerModule, NgxSpinnerService } from 'ngx-spinner';
import { Role, System, UserRole } from 'src/app/modules/user-profile/models/role-request.models';
import { Subject, Subscription, takeUntil } from 'rxjs';
import { AlertComponent } from 'src/app/modules/shared/components/alert/alert.component';

@Component({
    selector: 'app-role-information',
    imports: [CommonModule, FormsModule, RoleRequestCartComponent, NgSelectModule, TooltipModule, NgxSpinnerModule, SpinnerComponent, AlertComponent],
    templateUrl: './role-information.component.html',
    styleUrl: './role-information.component.css'
})
export class RoleInformationComponent implements OnInit, OnDestroy {
  roleRequestService = inject(RoleRequestService);
  private applicationService = inject(ApplicationService);
  private spinner = inject(NgxSpinnerService);

  roleSelectionType = "bySystem";
  dropdowns = {
    allSystemsKeys: [],
    userRoles: []
  };
  today = new Date().toISOString().split('T')[0];
  selectRoleDirectlyDtls = {
    reason: '',
    effectiveDate: JSON.parse(JSON.stringify(this.today)), 
  }
  systemsForSelectedRole: any[] = [];
  rolesForSelectedSystem: any[] = [];
  orgRolesForSelectedSystem: any[] = [];
  initialSelRoleForSystem: UserRole = null;
  
  selectedRoles: any[] = [];
  selectedSystem = null;
  private destroy$ = new Subject<void>();
  rolesOnCart = [];
  readonly addEmployeeRole = input(undefined);

  readonly onCartChange = output<any>();

  ngOnInit(): void {
    this.roleRequestService.isOrgChanged.pipe(takeUntil(this.destroy$)).subscribe(() => {
      this.showErrorMessage = '';
      this.selectedSystem = null;
      this.selectedRoles = [];
      this.rolesOnCart = [];
      this.rolesForSelectedSystem = [];
      this.orgRolesForSelectedSystem = [];
      this.systemsForSelectedRole = [];
      this.initialSelRoleForSystem = null;
      this.getApplicationRoles();
    });
  }

  getApplicationRoles() {
    this.spinner.show();
    const multiOrgFilters = this.roleRequestService.multiOrgFilters;
    this.roleRequestService.getRolesByUsageTypeAndAssignGroup(multiOrgFilters.selectedRoleGroup.roleAssignGroupKey)
    .pipe(takeUntil(this.destroy$)).subscribe((orgRoles:Role[])  => {  
      const uniqSet = new Set();
      this.dropdowns.userRoles = orgRoles.filter(role => {
        const roleName = role.roleName;
        if (!uniqSet.has(roleName)) {
          uniqSet.add(roleName);
          return true;
        }
        return false;
      }).sort((a, b) => {
        if (a.roleName < b.roleName) {
          return -1;
        }
        if (a.roleName > b.roleName) {
          return 1;
        }
        return 0;
      });

      this.dropdowns.userRoles = this.dropdowns.userRoles.map(x => {
        x['applicationRoleName'] = x.roleName;
        x['applicationRoleDescript'] = x.roleDescript;
        x['effectiveDate'] = this.today
        return x;
      });
      this.spinner.hide();
    });
    this.getAllSystemApplications();
  }

  selectedRole: any;
  getApplicationRolesByRoleKey(event: any) {
    this.showErrorMessage = '';
    this.selectedRole = event;
    if(!event || !event.roleResponsibilities?.length){
      this.systemsForSelectedRole = [];
      return;
    }
    this.systemsForSelectedRole = event.roleResponsibilities.map(x => {
      x = { ...x, ...event, applicationRoleName: event.roleName };
      return x;
    });
  }

  getApplicationRolesBySystem(system: string) {
    this.roleRequestService.getRolesBySystemAndAssignGroup(system, this.roleRequestService.multiOrgFilters.selectedRoleGroup.roleAssignGroupKey).subscribe(roles => {
      roles.forEach(x => {
        x['applicationRoleName'] = x.roleName;
        x['applicationRoleDescript'] = x.roleDescript;
        x['effectiveDate'] = this.today;
        x['roleResponsibilities'] = x.roleResponsibilities?.map(x => x.roleResponsibility.split('.'))?.flat()?.filter(x => x)?.map(x => x + '.');
      });
      this.rolesForSelectedSystem =  roles;
      this.orgRolesForSelectedSystem = roles;
    })
  }

  getAllSystemApplications() {
    this.spinner.show();
    this.roleRequestService.getAllSystemApplications().subscribe((systems: System[]) => {
      this.dropdowns.allSystemsKeys = systems.sort((a, b) => {
        if (a.systemName < b.systemName) {
          return -1;
        }
        if (a.systemName > b.systemName) {
          return 1;
        }
        return 0;
      });
      this.spinner.hide();
    })
  }

  onRoleSelectionTypeChange() {
    this.showErrorMessage = '';
  }

  onRoleCheckBoxChage(event: any, roleSelected: any) {
    this.showErrorMessage = '';
    if (event.target.checked) {
      if(!this.initialSelRoleForSystem || !this.initialSelRoleForSystem?.['reason']) {
        this.initialSelRoleForSystem = roleSelected;
      } else if(!roleSelected.reason) {
        roleSelected.reason = this.initialSelRoleForSystem?.['reason'];
      }
      this.selectedRoles.push(roleSelected);
    } else {
      this.selectedRoles = this.selectedRoles.filter(role => role.roleKey !== roleSelected.roleKey);
    }
  }

  isSelected(roleSel: any) {
    return this.selectedRoles.find(role => roleSel.roleKey == role.roleKey);
  }

  selectRoleNgModel = null;

  showError(message: string): void {
    this.showErrorMessage = message;
    window.scrollTo(0, 0);
  }

  showErrorMessage = '';
  addRolesToCart() {
    this.showErrorMessage = '';
    if(this.roleSelectionType === 'bySystem' && this.selectedRoles.some(role => !role.reason?.trim())) {
      this.showError("Please provide a reason to add the selected roles.");
      return;
    }

    if(this.roleSelectionType === 'byDirectly' && !this.selectRoleDirectlyDtls?.reason?.trim()) {
      this.showError("Please provide a reason to add the selected role.");
      return;
    }

    if (this.roleSelectionType === 'bySystem') {
      this.onRolesToCart(this.selectedRoles);
      this.rolesForSelectedSystem = this.rolesForSelectedSystem.filter(role => !this.rolesOnCart.some(selrole => selrole.roleKey == role.roleKey ) );

    } else {
      if (!this.systemsForSelectedRole?.length) {
        this.systemsForSelectedRole = [];
        this.systemsForSelectedRole.push(this.selectedRole);
      }
      this.systemsForSelectedRole = this.systemsForSelectedRole.map(x => ({
        ...x, ...this.selectRoleDirectlyDtls
      }))
      this.onRolesToCart(this.systemsForSelectedRole);
      this.systemsForSelectedRole = this.systemsForSelectedRole.filter(role => !this.rolesOnCart.some(selrole => selrole.roleKey == role.roleKey ) );
      this.selectRoleNgModel = null;
      this.selectedRole = null;
    }
    this.onCartChange.emit(JSON.parse(JSON.stringify(this.rolesOnCart)));
  }

  onRolesToCart(roles) {
    roles.forEach(role => {
      if (!this.rolesOnCart.find(x => x.roleKey === role.roleKey)) {
        this.rolesOnCart.push(role);
      }
    })
  }

  removeRole(role) {
    this.rolesOnCart = this.rolesOnCart.filter(x => x.roleKey !== role.roleKey);
    this.selectedRoles = this.selectedRoles.filter(x => x.roleKey !== role.roleKey);
    this.rolesForSelectedSystem = this.orgRolesForSelectedSystem.filter(role => !this.rolesOnCart.some(selrole => selrole.roleKey == role.roleKey ) );
    this.onCartChange.emit(JSON.parse(JSON.stringify(this.rolesOnCart)));
  }

  roleAndOrgSelected() {
    return (this.roleRequestService.multiOrgFilters.selectedOrganization && this.roleRequestService.multiOrgFilters.selectedRoleGroup) || this.roleRequestService.multiOrgFilters.selectedRoleGroup?.roleAssignGroupKey == '4';
  }
  
  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

}
